<template>
  <ul
    class="filtersList"
    :class="{
      hasExclusive: showExclusive,
    }"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="{
        'disabledFilter': item.disabled,
      }"
    >
      <div
        class="filtersListItem"
      >
        <BaseTooltip
          v-if="item.tooltipText"
          :text="item.tooltipText"
          :icon="item.tooltipIcon"
          :text-replace="item.tooltipTextReplace"
        />

        <BaseCheckbox
          class="filtersListCheckbox"
          :is-checked="item.isChecked"
          :value="item.value"
          @click="$emit('itemClicked', item)"
        >
          <span class="filtersListItemText">{{ item.text }}</span>
          <slot
            name="textEnd"
            :item="item"
          />
        </BaseCheckbox>
        <span
          v-if="showExclusive"
          class="exclusiveButton"
          @click.stop.prevent="$emit('exclusiveClicked', item)"
        >{{ $l('global.simplePhrases.only') }}</span>
      </div>
      <slot
        name="itemEnd"
        :item="item"
      />
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
	items: {
		type: Array,
		required: true
	},
	showExclusive: {
		type: Boolean,
		default: true
	}
});

defineEmits(['itemClicked', 'exclusiveClicked']);
</script>
